import * as Yup from 'yup';
export default function getYupValidationSchema(values) {
  return Yup.object().shape({
    companyCode: Yup.string()
      .trim()
      .required('CompanyCode is required!'),
    userId: Yup.string()
      .trim()
      .required('UserId is required!'),
    password: Yup.string()
      .trim()
      .required('Password is required!')
  });
}
